import React from 'react';

/**
 * Standard page title block for admin/staff pages. The layout's top bar shows
 * the breadcrumb; this is the one visible page title.
 *
 * <PageHeader title="Users" description="Manage user accounts" />
 * <PageHeader
 *   title="Order Approvals"
 *   description="Review orders before they're sent to Progress."
 *   meta={<span>3 pending</span>}
 *   actions={<Button icon={<Plus className="h-4 w-4" />}>Create User</Button>}
 * />
 */
function PageHeader({ title, description, meta, actions, className = '' }) {
  return (
    <div className={`flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between ${className}`}>
      <div className="min-w-0">
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        {description && <p className="mt-1 text-sm text-gray-600">{description}</p>}
        {meta && <div className="mt-2 flex flex-wrap items-center gap-3 text-sm text-gray-500">{meta}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:flex-shrink-0">{actions}</div>}
    </div>
  );
}

export default PageHeader;
